<template>
  <v-app>
    <v-toolbar
      app
      color="white"
      dark
    >
      <div class="d-flex align-center">
        <v-img
          alt="Demosle Logo"
          class="mr-2"
          contain
          :src="require('../../assets/static/img/logo-demosle.png')"
          transition="scale-transition"
          width="150"
          
        />
      </div>
      <v-spacer></v-spacer>
      <div v-if="!onRegister && $store.state.idCliente === ''">
        <v-btn  style="background-color: white; color: #9D4593;" flat @click="onRegister = true"> Crear cuenta</v-btn>
      </div>
      <div v-if="!onRegister && $store.state.idCliente === ''">
        <v-btn  style="background-color: #9D4593" @click="openLogin()"> Login</v-btn>
      </div>
      <div v-if="onRegister">
        <v-btn @click="onRegister = false">Cerrar</v-btn>
      </div>
      <div v-if="$store.state.idCliente != ''">
        <v-btn @click="closeSesion">Cerrar Sesion</v-btn>
      </div>
    </v-toolbar>
    <v-content>
      <!-- <mainForm v-if="!onRegister && $store.state.idCliente === ''"/> -->
      <register v-if="onRegister"/>
      <login/>
      <memberMenu v-if="$store.state.idCliente != ''"/>
    </v-content>
  </v-app>
</template>

<script>
import mainForm from './MainForm';
import register from './RegisterDemo'
import login from './LoginDemo'
import memberMenu from './MemberMenu'
import { EventBus } from '../../events.js'
import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

export default {
  name: 'Demo',

  components: {
    mainForm,
    register,
    login,
    memberMenu
  },

  data() {
   return {
    logo: './',
    onRegister: false,
    loged: false
   } 
  },
  methods: {
    openLogin() {
      EventBus.$emit('openLoginDemo', true)
    },
    closeSesion() {
        const self = this
        firebase.auth().signOut().then(() => {
          // Sign-out successful.
          self.loged = false
          self.$store.state.idCliente = ''
        }).catch((error) => {
          // An error happened.
        });
      },
      get_user(id) {
        console.log(id)
      }
  },
  mounted() {
    if (this.$store.state.idCliente) {
      this.get_user(this.$store.state.idCliente)
    }
    EventBus.$emit('logedUser', data => {
      if (data) {
        this.get_user(this.$store.state.idCliente)
      }
    })
    EventBus.$on('registeredUserDemo', data => {
      this.onRegister = false
    })
  }
};
</script>